var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isButton
    ? _c(
        "button",
        {
          staticClass: "file-chooser-item",
          class: {
            selected: _vm.isSelected,
            disabled: _vm.isFolderChooser,
          },
          attrs: {
            title: _vm.fileName,
          },
          on: {
            click: _vm.selectFile,
            dblclick: _vm.instantSelectFile,
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: _vm.fileIcon,
              size: 48,
            },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.fileName))]),
        ],
        1
      )
    : _c(
        "tr",
        {
          class: {
            selected: _vm.isSelected,
          },
        },
        [
          _c(
            "td",
            {
              staticClass: "document-icon",
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.selectFile.apply(null, arguments)
                    },
                    dblclick: function dblclick($event) {
                      $event.preventDefault()
                      return _vm.instantSelectFile.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: _vm.fileIcon,
                      size: 24,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("td", [
            _c(
              "a",
              {
                attrs: {
                  href: "#",
                },
                on: {
                  click: function click($event) {
                    $event.preventDefault()
                    return _vm.selectFile.apply(null, arguments)
                  },
                  dblclick: function dblclick($event) {
                    $event.preventDefault()
                    return _vm.instantSelectFile.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.fileName))]
            ),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.fileSize))]),
          _vm._v(" "),
          _c(
            "td",
            {
              staticClass: "responsive-hidden",
            },
            [_vm._v(_vm._s(_vm.fileOwner))]
          ),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.fileMkdate))]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }